import React from "react";

function Error404Page() {
    return (
        <div
            style={{
                backgroundColor: "white",
                color: "black",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                height: "100vh",
                fontFamily: "arial",
                textAlign: "center",
            }}
        >
            <div>
                Sorry but we can't find this page. Have you forgotten to add a <b>Brand</b> to the url?
            </div>
            {/*<div style={{marginTop: "20px"}}>Please write the url like this</div>*/}
            <div style={{ marginTop: "20px", fontSize: "20px" }}>
                https://returns.ingrid.com/
                <b>
                    <i>name-of-brand</i>
                </b>
            </div>
        </div>
    );
}

export default Error404Page;
